// extracted by mini-css-extract-plugin
module.exports = {"content":"styles_content__2mMOT","top":"styles_top__VXwmu"};